<input
	*ngIf="this.getInputType() === 'hidden'; else notHiddenFieldBlock"
	[attr.name]="name"
	type="hidden"
	[formControl]="control"
/>

<ng-template #notHiddenFieldBlock>
	<div [ngClass]="schema?.classNames?.widget">
		<label [attr.for]="id" [ngClass]="schema?.classNames?.title">{{ schema.title }}</label>
		<input
			trim="blur"
			[ngClass]="schema?.classNames?.input || 'form-control form-control-primary'"
			[attr.id]="id"
			[attr.name]="name"
			[attr.type]="this.getInputType()"
			[attr.placeholder]="schema.placeholder"
			[attr.maxLength]="schema.maxLength || null"
			[attr.minLength]="schema.minLength || null"
			[attr.disabled]="schema.widget.id === 'color' && schema.readOnly ? true : null"
			[attr.readonly]="schema.widget.id !== 'color' && schema.readOnly ? true : null"
			[formControl]="control"
		/>
		<input
			*ngIf="schema.widget.id === 'color' && schema.readOnly"
			type="hidden"
			[formControl]="control"
		/>
	</div>
</ng-template>

<div class="validation-error"> {{ control.errors | sfValidationError: schema : control.value }} </div>
